import request from "@/utils/request.js"
// 获取创新技术详情
export function hexinRead(data){
  return request({
    	  method:'GET',
    	  url:'/InnovationPlatform/read',
    	  params:data
    })
}
// 获取创新技术列表
export function get_list(data){
  return request({
    	  method:'GET',
    	  url:'/InnovationPlatform/get_list',
    	  params:data
    })
}
